import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Wallet, Download } from "lucide-react";
import api, { apiError } from "@/lib/api";

const uk = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString("en-GB") : "");

export function MyPay() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/me/payslips").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d) return null;
  const download = async (s) => {
    try {
      const r = await api.get(`/payslips/${s.id}/pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = `payslip_${s.period_from}.pdf`; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error(apiError(e)); }
  };
  const t = d.totals;
  const stat = (label, value, id) => (
    <div className="rounded-lg bg-ivory px-4 py-3" data-testid={`mypay-${id}`}>
      <p className="text-[11px] font-semibold uppercase tracking-wider text-ink-muted">{label}</p>
      <p className="font-heading text-xl font-bold text-ink">{value}</p>
    </div>
  );
  return (
    <div className="rounded-xl border border-border bg-white p-6 shadow-sm lg:col-span-2" data-testid="my-pay">
      <h2 className="mb-1 flex items-center gap-2 font-heading text-lg font-semibold text-ink"><Wallet size={18} className="text-brand" /> My pay</h2>
      <p className="mb-4 text-sm text-ink-soft">Totals for this tax year (from {uk(t.tax_year_from)}).</p>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {stat("Gross pay", `£${t.gross.toFixed(2)}`, "gross")}
        {stat("Hours", t.hours, "hours")}
        {stat("Visits", t.visits, "visits")}
        {stat("Mileage paid", `£${t.mileage_pay.toFixed(2)}`, "mileage")}
      </div>
      <div className="mt-5 divide-y divide-border rounded-lg border border-border">
        {d.payslips.length === 0 && <p className="p-4 text-sm text-ink-muted" data-testid="mypay-empty">No payslips yet. They appear here once the office approves payroll.</p>}
        {d.payslips.map((s) => (
          <div key={s.id} className="flex flex-wrap items-center gap-3 p-3 text-sm" data-testid={`payslip-${s.id}`}>
            <span className="flex-1 font-medium text-ink">{uk(s.period_from)} – {uk(s.period_to)}</span>
            <span className="text-ink-soft">{s.row.hours}h · {s.row.visits} visits</span>
            <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${s.status === "paid" ? "bg-sage-light text-sage-dark" : "bg-brand-light text-brand"}`}>{s.status === "paid" ? "Paid" : "Approved"}</span>
            <span className="font-semibold text-ink">£{s.gross_pay.toFixed(2)}</span>
            <button onClick={() => download(s)} data-testid={`download-payslip-${s.id}`} className="inline-flex items-center gap-1 rounded-lg border border-brand px-2.5 py-1 text-xs font-semibold text-brand hover:bg-brand-light"><Download size={12} /> PDF</button>
          </div>
        ))}
      </div>
    </div>
  );
}
